import { DeleteTask, List, EditPencil, Dots2 } from 'components/Icons';
import { Options as PopoverOptions } from 'components';

import styles from './styles.module.scss';

export const Options = ({ index, editHandler, removeHandler, isViewMode = false }) => {
  const editOption = {
    label: 'Edit',
    icon: <EditPencil />,
    onClick: () => editHandler(index),
  };

  const removeOption = {
    label: 'Remove',
    icon: <DeleteTask />,
    onClick: () => removeHandler(index),
  };

  if (isViewMode) return null;

  const OPTIONS = [editOption, removeOption];

  return (
    <div className={styles.taskOptions}>
      <PopoverOptions
        title={<Dots2 />}
        placement="bottom"
        options={OPTIONS}
        popoverClassName={styles.taskOptionsPopover}
        titleClassName={styles.optionsTitle}
      />
    </div>
  );
};
